var React = require('react');

function AlertOff (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M7.01 19.01C7.01 20.11 7.9 21 9 21s1.99-.89 1.99-1.99H7.01zm8.87-4.29L4.751 3.591A6.87 6.87 0 0 1 7.41 2.31v-.72C7.41.71 8.12 0 9 0c.88 0 1.59.71 1.59 1.59v.72c3.04.72 5.29 3.44 5.29 6.69v5.72zM1.28 2.66l16.73 16.73.003-.003-1.27 1.27L14.086 18H0v-1.06l2.12-2.12V9c0-.882.166-1.724.468-2.499L.013 3.927 1.28 2.66z"}));
}

AlertOff.defaultProps = {"width":"18","height":"21","viewBox":"0 0 18 21"};

module.exports = AlertOff;

AlertOff.default = AlertOff;
